<template>
  <board-member-create-form></board-member-create-form>
</template>

<script>
import BoardMemberCreateForm from "./CreateForm";
export default {
  name: "CreateBoardMemberPage",
  components: { BoardMemberCreateForm }
};
</script>

<style scoped></style>
